import ufrom from "../../../assets/dashboard/uform.svg";
import rectangle from "../../../assets/dashboard/rectangle.svg";
import lform from "../../../assets/dashboard/lform.svg";
import tform from "../../../assets/dashboard/tform.svg";
import ra from "../../../assets/dashboard/ra.svg";
import rb from "../../../assets/dashboard/rb.svg";
import la from "../../../assets/dashboard/la.svg";
import lb from "../../../assets/dashboard/lb.svg";
import lc from "../../../assets/dashboard/lc.svg";
import ld from "../../../assets/dashboard/ld.svg";

import ta from "../../../assets/dashboard/ta.svg";
import tb from "../../../assets/dashboard/tb.svg";
import tc from "../../../assets/dashboard/tc.svg";
import td from "../../../assets/dashboard/td.svg";

import ua from "../../../assets/dashboard/ua.svg";
import ub from "../../../assets/dashboard/ub.svg";
import uc from "../../../assets/dashboard/uc.svg";
import ud from "../../../assets/dashboard/ud.svg";

import rektangle from "../../../assets/dashboard/recktangle.svg";

import customShape from "../../../assets/dashboard/customShape.svg";
import indi from "../../../assets/dashboard/indi.svg";
import { needCertificateGerText } from "../../../Utility/gerLangObject";
import { needCertificateEngText } from "../../../Utility/engLangObject";

export const threeYearsBack = (sub = 1) => {
  const currentDate = new Date(); // Get the current date
  const threeYearsBack = new Date(); // Create a new Date object
  return new Date(threeYearsBack.setFullYear(currentDate.getFullYear() - sub)); // Subtract 3 years
};

export const incrementByOneYear = (sub = 1, date) => {
  const toDate = new Date(date);

  // Increment the year by 1
  toDate.setFullYear(toDate.getFullYear() + sub);
  // Convert the Date object back to a string in the format YYYY-MM-DD
  const incrementedDate = toDate.toISOString().split("T")[0];
  // Update the to_date field in the data object
  return incrementedDate;
};

export const monthYear = (date) => {
  // const myDate = date.getMonth();
  // const myYear = date.getFullYear();
  // return `${months[myDate]}  ${myYear}`;
};

// Create an array of month names
export const months = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

export const germanMonths = [
  "Januar",
  "Februar",
  "März",
  "April",
  "Mai",
  "Juni",
  "Juli",
  "August",
  "September",
  "Oktober",
  "November",
  "Dezember",
];

export const YYMMDD = (date) => {
  const yy = date.getFullYear().toString();
  const mm = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const dd = date.getDate().toString().padStart(2, "0");

  const formattedDate = `${yy}-${mm}-${dd}`;
  return formattedDate;
};

export const formStep1 = [
  {
    title: needCertificateEngText.occasion,
    id: 1,
    select: false,
    name: "occasion_id",
    type: "text",
    required: true,
    fieldType: 3,
    popData: [
      {
        heading: needCertificateEngText.occasion,
        para1: needCertificateEngText.occasion_paragraph,
      },
    ],
  },

  {
    title: needCertificateEngText.building_type,
    id: 3,
    select: false,
    name: "building_type_id",
    type: "text",
    required: true,
    fieldType: 3,
    popData: [
      {
        heading: needCertificateEngText.building_type,
        para1: needCertificateEngText.building_type_paragraph,
      },
    ],
  },

  {
    title: needCertificateEngText.number_of_apartments,
    id: 5,
    select: false,
    name: "number_of_apartments",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: needCertificateEngText.number_of_apartments,
        para1: needCertificateEngText.number_of_apartments_paragraph,
      },
    ],
  },
  {
    title: needCertificateEngText.year_of_construction,
    id: 4,
    select: false,
    name: "construction_year",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: needCertificateEngText.year_of_construction,
        para1: needCertificateEngText.year_of_construction_paragraph,
      },
    ],
  },
  {
    title: needCertificateEngText.no_of_floors,
    id: 2,
    select: false,
    name: "number_of_floors",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: needCertificateEngText.no_of_floor,
        para1: needCertificateEngText.no_of_floors_info,
      },
    ],
  },
  {
    title: needCertificateEngText.eMail,
    id: 6,
    select: false,
    name: "email",
    type: "email",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: needCertificateEngText.eMail,
        para1: needCertificateEngText.eMail_para_1,
        para2: needCertificateEngText.eMail_para_2,
      },
    ],
  },
];

export const formStep1_german = [
  {
    title: needCertificateGerText.occasion,
    id: 1,
    select: false,
    name: "occasion_id",
    type: "text",
    required: true,
    fieldType: 3,
    popData: [
      {
        heading: needCertificateGerText.occasion,
        para1: needCertificateGerText.Occasion_desc,
      },
    ],
  },

  {
    title: needCertificateGerText.building_type,
    id: 3,
    select: false,
    name: "building_type_id",
    type: "text",
    required: true,
    fieldType: 3,
    popData: [
      {
        heading: needCertificateGerText.building_type,
        para1: needCertificateGerText.build_desc,
      },
    ],
  },

  {
    title: needCertificateGerText.number_of_apartments,
    id: 5,
    select: false,
    name: "number_of_apartments",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: needCertificateGerText.number_of_apartments,
        para1: needCertificateGerText.num_aprtdesc,
      },
    ],
  },
  {
    title: needCertificateGerText.year_of_construction,
    id: 4,
    select: false,
    name: "construction_year",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: needCertificateGerText.year_of_construction,
        para1: needCertificateGerText.year_of_construction_paragraph,
      },
    ],
  },
  {
    title: needCertificateGerText.no_of_floors,
    id: 2,
    select: false,
    name: "number_of_floors",
    type: "number",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: needCertificateGerText.no_of_floor,
        para1: needCertificateGerText.no_of_floors_info,
      },
    ],
  },
  {
    title: needCertificateGerText.eMail,
    id: 6,
    select: false,
    name: "email",
    type: "email",
    required: true,
    fieldType: 1,
    popData: [
      {
        heading: needCertificateGerText.eMail,
        para1: needCertificateGerText.e_para_1,
        para2: needCertificateGerText.e_para_2,
      },
    ],
  },
];

export const steps = [
  {
    id: 1,
    step: needCertificateEngText.step_1,
    info: needCertificateEngText.building_info,
    required: true,
  },
  {
    id: 2,
    step: needCertificateEngText.step_2,
    info: needCertificateEngText.structure_details,
    required: true,
  },
  {
    id: 3,
    step: needCertificateEngText.step_3,
    info: needCertificateEngText.building_component,
    required: true,
  },
  {
    id: 4,
    step: needCertificateEngText.step_4,
    info: needCertificateEngText.heat_generator_details,
    required: true,
  },
  {
    id: 5,
    step: needCertificateEngText.step_5,
    info: needCertificateEngText.property_address,
    required: true,
  },
  {
    id: 6,
    step: needCertificateEngText.step_6,
    info: needCertificateEngText.file_upload,
    required: true,
  },
  {
    id: 7,
    step: needCertificateEngText.step_7,
    info: needCertificateEngText.certificate,
    required: true,
  },
  {
    id: 8,
    step: needCertificateEngText.step_8,
    info: needCertificateEngText.billing_delivery_address,
    required: true,
  },
];

export const steps_german = [
  {
    id: 1,
    step: needCertificateGerText.step_1,
    info: needCertificateGerText.building_info,
    required: true,
  },
  {
    id: 2,
    step: needCertificateGerText.step_2,
    info: needCertificateGerText.structure_details,
    required: true,
  },
  {
    id: 3,
    step: needCertificateGerText.step_3,
    info: needCertificateGerText.building_component,
    required: true,
  },
  {
    id: 4,
    step: needCertificateGerText.step_4,
    info: needCertificateGerText.heat_generator_details,
    required: true,
  },
  {
    id: 5,
    step: needCertificateGerText.step_5,
    info: needCertificateGerText.property_address,
    required: true,
  },
  {
    id: 6,
    step: needCertificateGerText.step_6,
    info: needCertificateGerText.file_upload,
    required: true,
  },
  {
    id: 7,
    step: needCertificateGerText.step_7,
    info: needCertificateGerText.certificate,
    required: true,
  },
  {
    id: 8,
    step: needCertificateGerText.step_8,
    info: needCertificateGerText.billing_delivery_address,
    required: true,
  },
];

export const structure_type = [
  {
    title: "Rectangle",
    id: 1,
    img: rectangle,
    img_german: rektangle,
  },
  {
    title: "L-Form",
    id: 2,
    img: lform,
    img_german: lform,
  },
  {
    title: "T-Form",
    id: 3,
    img: tform,
    img_german: tform,
  },
  {
    title: "U-Form",
    id: 4,
    img: ufrom,
    img_german: ufrom,
  },
  {
    title: "Custom",
    id: 5,
    img: customShape,
    img_german: indi,
  },
];

export const structure = [
  {
    id: 1,
    wall_details: [
      {
        length: null,
        index: 1,
        img: ra,
        name: "a",
      },
      {
        length: null,
        index: 2,
        img: rb,
        name: "b",
      },
    ],
  },
  {
    id: 2,
    wall_details: [
      {
        length: null,
        index: 1,
        img: la,
      },
      {
        length: null,
        index: 2,
        img: lb,
      },
      {
        length: null,
        index: 3,
        img: lc,
      },
      {
        length: null,
        index: 4,
        img: ld,
      },
    ],
  },
  {
    id: 3,
    wall_details: [
      {
        length: null,
        index: 1,
        img: ta,
      },
      {
        length: null,
        index: 2,
        img: tb,
      },
      {
        length: null,
        index: 3,
        img: tc,
      },
      {
        length: null,
        index: 4,
        img: td,
      },
    ],
  },
  {
    id: 4,
    wall_details: [
      {
        length: null,
        index: 1,
        img: ua,
      },
      {
        length: null,
        index: 2,
        img: ub,
      },
      {
        length: null,
        index: 3,
        img: uc,
      },
      {
        length: null,
        index: 4,
        img: ud,
      },
    ],
  },
  {
    id: 5,
    wall_details: [
      {
        length: null,
        index: 1,
        img: ua,
      },
      {
        length: null,
        index: 2,
        img: ub,
      },
      {
        length: null,
        index: 3,
        img: uc,
      },
      {
        length: null,
        index: 4,
        img: ud,
      },
    ],
  },
];

export const constructionType = [
  {
    value: "solid_construction",
    id: 1,
    title: needCertificateEngText.solid_construction,
    german_title: needCertificateGerText.solid_construction,
  },
  {
    value: "wooden_construction",
    id: 2,
    title: needCertificateEngText.wooden_construction,
    german_title: needCertificateGerText.wooden_construction,
  },
];

export const wing = [
  {
    value: "total_building",
    id: 1,
    title: needCertificateEngText.total_building,
    german_title: needCertificateGerText.total_building,
  },
  {
    value: "residential_part",
    id: 2,
    title: needCertificateEngText.residential_part,
    german_title: needCertificateGerText.residential_part,
  },
];

export const coolingSystem = [
  {
    value: "from_electricity",
    id: 1,
    title: needCertificateEngText.from_electricity,
    german_title: needCertificateGerText.from_electricity,
  },
  {
    value: "delivered_cold",
    id: 2,
    title: needCertificateEngText.delivered_cold,
    german_title: needCertificateGerText.delivered_cold,
  },
  {
    value: "passive_cooling",
    id: 3,
    title: needCertificateEngText.passive_cooling,
    german_title: needCertificateGerText.passive_cooling,
  },
  {
    value: "cooling_from_heat",
    id: 4,
    title: needCertificateEngText.cooling_from_heat,
    german_title: needCertificateGerText.cooling_from_heat,
  },
];

export const outsideAir = [
  {
    value: "compliance_with_tightness",
    id: 1,
    title: needCertificateEngText.compliance_with_tightness,
    german_title: needCertificateGerText.compliance_with_tightness,
  },
  {
    value: "without_leak_test",
    id: 2,
    title: needCertificateEngText.without_leak_test,
    german_title: needCertificateGerText.without_leak_test,
  },
  {
    value: "obvious_leaks",
    id: 4,
    title: needCertificateEngText.obvious_leaks,
    german_title: needCertificateGerText.obvious_leaks,
  },
  {
    value: "other",
    id: 3,
    title: needCertificateEngText.other,
    german_title: needCertificateGerText.other,
  },
];

export const insulationFields = [
  {
    insulation_on: 1,
    length: 0,
    title: "Insulation (Exterior Walls)",
    title_germ: "Dämmung (Außenwände)",
  },
  {
    insulation_on: 2,
    length: 0,
    title: "Insulation (Roof or Top ceiling)",
    title_germ: "Dämmung (Dach oder oberste Decke)",
  },
  {
    insulation_on: 3,
    length: 0,
    title: "Insulation (Floor / Basement)",
    title_germ: "Dämmung (Boden/Keller)",
  },
  {
    insulation_on: 4,
    length: 0,
    title: "Insulation (Basement walls)",
    title_germ: "Dämmung (Kellerwände)",
  },
];

export const celingConstructionType = [
  {
    id: 1,
    value: "Reinforced_concrete_construction",
    title: needCertificateEngText.concrete_construction,
    german_title: needCertificateGerText.concrete_construction,
  },
  {
    id: 2,
    value: "Wooden_construction",
    title: needCertificateEngText.wooden_construction,
    german_title: needCertificateGerText.wooden_construction,
  },
  {
    id: 3,
    value: "Other",
    title: needCertificateEngText.other,
    german_title: needCertificateGerText.other,
  },
];

export const belowGroundFloor = [
  {
    id: 1,
    value: "unheated_basement",
    title: needCertificateEngText.unheated_basement,
    german_title: needCertificateGerText.unheated_basement,
  },
  {
    id: 2,
    value: "heated_cellar",
    title: needCertificateEngText.heated_cellar,
    german_title: needCertificateGerText.heated_cellar,
  },
  {
    id: 3,
    value: "no_basement",
    title: needCertificateEngText.no_basement,
    german_title: needCertificateGerText.no_basement,
  },
];

export const heatedPercent = [
  { id: 0, value: 0, title: "0" },
  { id: 5, value: 5, title: "5" },
  { id: 10, value: 10, title: "10" },
  { id: 15, value: 15, title: "15" },
  { id: 20, value: 20, title: "20" },
  { id: 25, value: 25, title: "25" },
  { id: 30, value: 30, title: "30" },
  { id: 35, value: 35, title: "35" },
  { id: 40, value: 40, title: "40" },
  { id: 45, value: 45, title: "45" },
  { id: 50, value: 50, title: "50" },
  { id: 55, value: 55, title: "55" },
  { id: 60, value: 60, title: "60" },
  { id: 65, value: 65, title: "65" },
  { id: 70, value: 70, title: "70" },
  { id: 75, value: 75, title: "75" },
  { id: 80, value: 80, title: "80" },
  { id: 85, value: 85, title: "85" },
  { id: 90, value: 90, title: "90" },
  { id: 95, value: 95, title: "95" },
  { id: 100, value: 100, title: "100" },
];

export const distributionHeating = [
  {
    id: 1,
    title: needCertificateEngText.central_distribution,
    german_title: needCertificateGerText.central_distribution,
  },
  {
    id: 2,
    title: needCertificateEngText.apartment_wise,
    german_title: needCertificateGerText.apartment_wise,
  },
  {
    id: 3,
    title: needCertificateEngText.decentralized_distribution,
    german_title: needCertificateGerText.decentralized_distribution,
  },
];

export const typesOfRenewableEnergy = [
  {
    id: 1,
    title: needCertificateEngText.unheated_basement,
    german_title: needCertificateGerText.unheated_basement,
  },
  {
    id: 2,
    title: needCertificateEngText.photovoltaics,
    german_title: needCertificateGerText.photovoltaics,
  },
  {
    id: 3,
    title: needCertificateEngText.heat_pump,
    german_title: needCertificateGerText.heat_pump,
  },
  {
    id: 4,
    title: needCertificateEngText.biomass,
    german_title: needCertificateGerText.biomass,
  },
];

export const directions = [
  {
    id: 1,
    title: "North",
  },
  {
    id: 2,
    title: "North East",
  },
  {
    id: 3,
    title: "East",
  },
  {
    id: 4,
    title: "South East",
  },
  {
    id: 5,
    title: "South",
  },
  {
    id: 6,
    title: "South West",
  },
  {
    id: 7,
    title: "West",
  },
  {
    id: 8,
    title: "North West",
  },
];

export const directionsGerm = [
  {
    id: 1,
    title: "Norden",
  },
  {
    id: 2,
    title: "Nordosten",
  },
  {
    id: 3,
    title: "Ost",
  },
  {
    id: 4,
    title: "Südosten",
  },
  {
    id: 5,
    title: "Süd",
  },
  {
    id: 6,
    title: "Südwesten",
  },
  {
    id: 7,
    title: "West",
  },
  {
    id: 8,
    title: "Nordwesten",
  },
];

const windowDetails = {
  window_type_id: null,
  length: null,
  width: null,
};

export const atticTypes = [
  {
    id: 1,
    title: needCertificateEngText.solid_ceiling,
    german_title: needCertificateGerText.solid_ceiling,
  },
  {
    id: 2,
    title: needCertificateEngText.wooden_ceiling,
    german_title: needCertificateGerText.wooden_ceiling,
  },
];

export const degreeArr = [
  { id: 5, title: 5 },
  { id: 10, title: 10 },
  { id: 15, title: 15 },
  { id: 20, title: 20 },
  { id: 25, title: 25 },
  { id: 30, title: 30 },
  { id: 35, title: 35 },
  { id: 40, title: 40 },
  { id: 45, title: 45 },
  { id: 50, title: 50 },
  { id: 55, title: 55 },
  { id: 60, title: 60 },
  { id: 65, title: 65 },
  { id: 70, title: 70 },
  { id: 75, title: 75 },
  { id: 80, title: 80 },
  { id: 85, title: 85 },
  { id: 90, title: 90 },
];

export const booleanValue = [
  {
    id: 1,
    title: needCertificateEngText.heated_attic,
    german_title: needCertificateGerText.heated_attic,
  },
  {
    id: 2,
    title: needCertificateEngText.unheated_attic,
    german_title: needCertificateGerText.unheated_attic,
  },
];
export const partiallyHeadEng = {
  popData: [
    {
      heading: needCertificateEngText.per_first_floor,
      para1: needCertificateEngText.per_first_floor_info,
    },
  ],
};
export const partiallyHeadGer = {
  popData: [
    {
      heading: needCertificateGerText.per_first_floor,
      para1: needCertificateGerText.per_first_floor_info,
    },
  ],
};

export const clearId = (arr, key) => {
  return arr.map((item, index) => {
    return { ...item, [key]: null };
  });
};
